import { ref } from 'vue';
import { useUser } from './useUser';
import store from '../store';

// Singleton state — dùng chung trên toàn app
const currentUser = ref(null);
const isLoaded = ref(false);

export function useCurrentUser() {
  const { getMyProfileApi } = useUser();

  const loadCurrentUser = async () => {
    if (isLoaded.value) return; // đã load rồi thì bỏ qua
    const res = await getMyProfileApi();
    if (res.success) {
      currentUser.value = res.data;
      const role = res.data.roles?.[0]?.name;
      if (role) {
        localStorage.setItem('user_role', role);
        store.dispatch('menu/setRole', role);
      }
      isLoaded.value = true;
    }
  };

  const reloadCurrentUser = async () => {
    isLoaded.value = false;
    const res = await getMyProfileApi();
    if (res.success) {
      currentUser.value = res.data;
      const role = res.data.roles?.[0]?.name;
      if (role) {
        localStorage.setItem('user_role', role);
        store.dispatch('menu/setRole', role);
      }
      isLoaded.value = true;
    }
  };

  const clearCurrentUser = () => {
    currentUser.value = null;
    isLoaded.value = false;
    localStorage.removeItem('user_role');
    store.dispatch('menu/setRole', 'guest');
  };

  return { currentUser, isLoaded, loadCurrentUser, reloadCurrentUser, clearCurrentUser };
}
